import { getDate, getDateTime } from '@/utils/time';
import moment from 'moment';
import React from 'react';
export const GetAdapterColumns = (
  columns,
  otherColumns,
  enableSorting,
  needNum = false,
  needNumWidth = 70,
  t,
  disabled = false
) => {
  //字典
  const getTitle = (col_) => {
    //设置title
    let title = t(col_.title) ?? col_.title;
    return (
      <>
        {title}
        {col_?.useEditNotRequiredTitle && !disabled ? (
          <span
            style={
              col_?.editNotRequiredStyle
                ? col_?.editNotRequiredStyle
                : { color: '#096' }
            }
          >
            {col_?.editNotRequiredIcon ? col_?.editNotRequiredIcon : '[+]'}
          </span>
        ) : (
          ''
        )}
        {col_?.useEditRequiredTitle && !disabled ? (
          <span
            style={
              col_?.editRequiredStyle
                ? col_?.editRequiredStyle
                : { color: 'red' }
            }
          >
            {' '}
            {col_?.editRequiredIcon ? col_?.editRequiredIcon : '(*)'}
          </span>
        ) : (
          ''
        )}
      </>
    );
  };
  const formatCol = (col) => {
    //格式化列
    const newCol = { ...col };
    newCol.dataIndex = col.key;
    if (enableSorting) {
      newCol.sorter = col.enableSorting
        ? true
        : enableSorting
          ? enableSorting
          : undefined;
    }
    newCol.enableSorting = undefined;
    newCol.render = col.render
      ? (_, item, index) => {
        let rst = col.render(item, index, _);
        if (!rst && isNaN(rst)) rst = '';
        return rst;
      }
      : undefined;
    newCol.bodyCellStyle = col.style;
    newCol.style = undefined;
    newCol.title = getTitle(newCol, t, disabled);
    if (newCol.renderType) {
      //设置默认render
      switch (newCol.renderType) {
        case 'date': //日期类型
          newCol.render = (_, item, index) => {
            let date = getDate(item[newCol.key]);
            return moment(date).isValid() ? date : item[newCol.key];
          };
          break;
        case 'dateTime': //时间类型类型  format：自定义格式化
          newCol.render = (_, item, index) => {
            let date = getDateTime(
              item[newCol.key],
              newCol.format ?? 'yyyy-MM-DD HH:mm'
            );
            return moment(date).isValid() ? date : item[newCol.key];
          };
          break;
          case 'bool': //布尔值
          newCol.render = (_, item, index) => {
            return item[newCol.key] ? t('t_yes') : t('t_no');
          };
          break;
          default:
          break;
      }
    }
    return newCol;
  };
  const newCols = [];
  if (needNum) {
    newCols.push({
      title: t('common.no'),
      key: 'commonNo',
      width: needNumWidth,
      fixed: 'left',
      align: 'center',
      render: (_, item, i) => {
        return i + 1;
      },
    });
  }
  for (let index = 0; index < columns.length; index++) {
    const col = columns[index];
    const newCol = formatCol(col);
    if (newCol?.children) {
      //新增有子集 2024-02-22
      let secondCols = [];
      for (let index = 0; index < newCol?.children.length; index++) {
        const col = newCol.children[index];
        const newCol2 = formatCol(col);
        secondCols.push(newCol2);
      }
      newCol.children = secondCols;
    }
    newCols.push(newCol);
  }
  otherColumns && newCols.push(...otherColumns);
  return newCols;
};

